import React from 'react';

const About = () => {
    return (
        <div className="font">
            <h2> About </h2>
            <p className="p-3 my-3">About Healthcare Success
                Healthcare Success is a full-service <br /> marketing and advertising agency dedicated exclusively to  helping healthcare organizations attract new patients,<br />  enhance their reputations (brands) and maximizetheir business success. Our clients include hospitals, medical<br />  practices, pharmaceuticals, manufacturers,<br />  dental and other practices.</p>
        </div>
    );
};

export default About;